import NavBarContent from './NavBarContent'

const NavBar = () => <NavBarContent />

export default NavBar
